module.exports = __webpack_public_path__ + "static/img/sino.9b80120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/sino.png
// module id = 50rY
// module chunks = 1